import React, { useState } from 'react';
import PanelCorrelaciones from './PanelCorrelaciones';
import PanelExcepcion from './PanelExcepciones';
import './styles/PanelSidebar.css';

const PanelSidebar = ({
  startDemoAnimation,
  hostsDisponibles,
  mapAux,
  setCapas,
  capas,
  demoRelaciones,
  setDemoRelaciones,
  demoExcepciones,
  setDemoExcepciones,
  CreateCisModalOpen,
}) => {
  const [panelAbierto, setPanelAbierto] = useState('correlaciones'); // 'correlaciones' | 'excepciones' | null

  const toggle = panel =>
    setPanelAbierto(prev => (prev === panel ? null : panel));

  if (CreateCisModalOpen) return null;

  return (
    <div className="sidebar-container">

      {/* ── Tabs de selección ── */}
      <div className="sidebar-tabs">
        <button
          className={`sidebar-tab ${panelAbierto === 'correlaciones' ? 'sidebar-tab--active' : ''}`}
          onClick={() => toggle('correlaciones')}
        >
          Correlaciones
          {demoRelaciones.length > 0 && (
            <span className="sidebar-tab-badge sidebar-tab-badge--blue">
              {demoRelaciones.length}
            </span>
          )}
        </button>
        <button
          className={`sidebar-tab ${panelAbierto === 'excepciones' ? 'sidebar-tab--active' : ''}`}
          onClick={() => toggle('excepciones')}
        >
          Excepciones
          {demoExcepciones.length > 0 && (
            <span className="sidebar-tab-badge sidebar-tab-badge--purple">
              {demoExcepciones.length}
            </span>
          )}
        </button>
      </div>

      {/* ── Paneles — solo uno visible a la vez ── */}
      {panelAbierto === 'correlaciones' && (
        <PanelCorrelaciones
          startDemoAnimation={startDemoAnimation}
          hostsDisponibles={hostsDisponibles}
          mapAux={mapAux}
          setCapas={setCapas}
          capas={capas}
          demoRelaciones={demoRelaciones}
          setDemoRelaciones={setDemoRelaciones}
          CreateCisModalOpen={false}
        />
      )}

      {panelAbierto === 'excepciones' && (
        <PanelExcepcion
          hostsDisponibles={hostsDisponibles}
          demoExcepciones={demoExcepciones}
          setDemoExcepciones={setDemoExcepciones}
          CreateCisModalOpen={false}
        />
      )}

    </div>
  );
};

export default PanelSidebar;
